export function getRequestHeaders(token: string) {
  return {
    Authorization: token ? `Bearer ${token}` : undefined,
    // TODO: add why this header is needed (ask Lisa)
    'x-no-gzip-response': 'true',
  };
}
